import { useQuery } from '@tanstack/react-query';
import {
  AccountDetailH2hEntity,
  BidvBankTransferService,
  LookupAccountDto,
} from 'services/openapi';

import { BidvBankTransferServiceKeys } from './constants';

export const useBidvLookupAccountQuery = (
  variables: LookupAccountDto,
  enabled: boolean = false,
) => {
  const queryKey = [BidvBankTransferServiceKeys.LOOKUP_ACCOUNT, variables];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<AccountDetailH2hEntity, Error>({
    queryKey,
    queryFn: () =>
      BidvBankTransferService.bidvBankTransferControllerLookupAccount(
        variables,
      ),
    retry: 0,
    refetchOnWindowFocus: false,
    enabled: enabled && !!variables.accountNo && !!variables.transferMethod,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
